import React from "react";
import classes from "./css/Line.module.css";

const Line = ({ type, className, style, onClick, children }) => {
  const returnClassNames = (baseClassName) => {
    if (className) {
      return baseClassName + " " + className;
    } else {
      return baseClassName;
    }
  }

  if (type === "bottom-line") {
    return (
      <div className={returnClassNames(classes.bottomLine)} style={{ ...style }} onClick={onClick}>
        {children}
      </div>
    )
  } else if (type === "top-line") {
    return (
      <div className={returnClassNames(classes.topLine)} style={{ ...style }} onClick={onClick}>
        {children}
      </div>
    )
  }
  else return (
    <div className={returnClassNames(classes.emptyLine)} style={{ ...style }} onClick={onClick}>
      {children}
    </div>
  )
}

export default Line;
